import { trapFocus } from '../utilities/accessibility';

const dropdowns = document.querySelectorAll("#main-nav .dropdown, #pre-nav .dropdown");
const showClass = "show";

function handleMouseover(dropdownMenu) {
	return function () {
		// Close any mega menus that might be open before opening the dropdown to prevent overlap
		const allMegaMenuContainers = document.querySelectorAll('#main-nav .mega-menu-container');
		if(allMegaMenuContainers.length > 0) {
			allMegaMenuContainers.forEach(item => item.classList.remove('show'));
		}

		dropdownMenu.classList.add(showClass);
		dropdownMenu.setAttribute('aria-expanded', 'true');
		document.body.classList.add('dropdown-menu-open');
	};
}

function handleMouseout(dropdownMenu) {
	return function () {
		dropdownMenu.classList.remove(showClass);
		dropdownMenu.setAttribute('aria-expanded', 'false');
		document.body.classList.remove('dropdown-menu-open');
	};
}

function handleKeydown(dropdownMenu, item) {
	return function (event) {
		if (event.key === ' ') {
			event.preventDefault();
			dropdownMenu.classList.toggle(showClass);
			dropdownMenu.setAttribute('aria-expanded', dropdownMenu.classList.contains(showClass));
			document.body.classList.add('dropdown-menu-open');
			trapFocus(item);
		}
	};
}

function checkMatchMedia() {
	dropdowns.forEach(item => {
		const dropdownMenu = item.querySelector(".dropdown-menu");

		if (!item.getAttribute('js-listeners-attached')) {
			item.setAttribute('js-listeners-attached', 'true');

			item.addEventListener('mouseover', handleMouseover(dropdownMenu));
			item.addEventListener('mouseout', handleMouseout(dropdownMenu));
			item.addEventListener('keydown', handleKeydown(dropdownMenu, item));
		}
	});
}

window.addEventListener('load', checkMatchMedia);